import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.collab.chat');
import { OnInit, OnDestroy, Input, ViewChild, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router } from '@angular/router';

interface Message {
    id: string;
    room_id: string;
    sender_id: string;
    type: string;
    content: string;
    attachments?: any[];
    mentions?: string[];
    parent_message_id?: string;
    pinned?: boolean;
    edited_at?: string;
    deleted?: boolean;
    created?: string;
    _reactions?: any;
}

interface Room {
    id: string;
    type: string;
    name?: string;
    workspace_id?: string;
    last_message_at?: string;
    last_message_id?: string;
    _member?: any;
    _unread?: number;
    members?: any[];
}

@Component({
    selector: 'wiz-portal-lpsysadmin-collab-chat',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.collab.chat/view.scss */
:host {
  display: block;
  height: 100%;
}

.chat-msg {
  word-break: break-word;
}

.chat-msg pre {
  background: #f4f4f5;
  padding: 8px 12px;
  border-radius: 6px;
  overflow-x: auto;
}

.chat-msg code {
  background: #f4f4f5;
  padding: 1px 4px;
  border-radius: 3px;
  font-size: 12px;
}`],
})
export class PortalLpsysadminCollabChatComponent implements OnInit, OnDestroy {
    @Input() room_id: string = '';

    public loaded: boolean = false;
    public rooms: Room[] = [];
    public room: Room | null = null;
    public messages: Message[] = [];
    public reactions: any = {};
    public pinnedMessages: Message[] = [];
    public newMessage: string = '';
    public roomFilter: string = '';
    public showCreateRoom: boolean = false;
    public newRoom: any = { type: 'group', name: '', members: '' };
    public showInfo: boolean = false;
    public showSearch: boolean = false;
    public searchText: string = '';
    public searchResults: Message[] = [];
    public replyTo: Message | null = null;
    public editingId: string = '';
    public editingContent: string = '';
    public showPinned: boolean = false;
    public emojis: string[] = ['👍', '❤️', '🎉', '😄', '🤔', '🚀', '✅', '👀'];
    private pollHandle: any = null;
    private lastMessageId: string = '';

    @ViewChild('msgScroll') msgScroll!: ElementRef;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadRooms();
        if (this.room_id) {
            await this.openRoom(this.room_id);
        }
        this.loaded = true;
        // Poll every 5 seconds for new messages (fallback for non-socket mode)
        this.pollHandle = setInterval(() => this.poll(), 5000);
        await this.service.render();
    }

    public ngOnDestroy() {
        if (this.pollHandle) clearInterval(this.pollHandle);
    }

    public async loadRooms() {
        const res = await wiz.call('rooms');
        if (res.code === 200) {
            this.rooms = res.data || [];
        }
        await this.service.render();
    }

    public filteredRooms(): Room[] {
        if (!this.roomFilter) return this.rooms;
        const q = this.roomFilter.toLowerCase();
        return this.rooms.filter(r => (r.name || '').toLowerCase().includes(q));
    }

    public async openRoom(rid: string) {
        const res = await wiz.call('open', { room_id: rid });
        if (res.code !== 200) {
            this.service.alert.show({ title: '오류', message: res.data || '방을 열 수 없습니다.', action: '확인' });
            return;
        }
        this.room = res.data.room;
        this.messages = res.data.messages || [];
        this.reactions = res.data.reactions || {};
        this.pinnedMessages = res.data.pinned || [];
        this.replyTo = null;
        this.lastMessageId = this.messages.length > 0 ? this.messages[this.messages.length - 1].id : '';
        if (rid !== this.room_id) {
            this.router.navigateByUrl(`/admin/collab/chat/${rid}`);
        }
        await this.service.render();
        this.scrollToBottom();
    }

    public async poll() {
        if (!this.room) return;
        const res = await wiz.call('poll', { room_id: this.room.id, after_id: this.lastMessageId });
        if (res.code === 200 && res.data && res.data.messages && res.data.messages.length > 0) {
            this.messages = this.messages.concat(res.data.messages);
            Object.assign(this.reactions, res.data.reactions || {});
            this.lastMessageId = this.messages[this.messages.length - 1].id;
            await this.service.render();
            this.scrollToBottom();
        }
        // refresh unread on rooms list silently
        const rres = await wiz.call('rooms');
        if (rres.code === 200) {
            this.rooms = rres.data || [];
            await this.service.render();
        }
    }

    public scrollToBottom() {
        setTimeout(() => {
            if (this.msgScroll && this.msgScroll.nativeElement) {
                const el = this.msgScroll.nativeElement;
                el.scrollTop = el.scrollHeight;
            }
        }, 50);
    }

    public async send() {
        if (!this.newMessage.trim() || !this.room) return;
        const params: any = { room_id: this.room.id, content: this.newMessage };
        if (this.replyTo) params.parent_message_id = this.replyTo.id;
        const res = await wiz.call('send', params);
        if (res.code !== 200) {
            this.service.alert.show({ title: '오류', message: res.data || '전송 실패', action: '확인' });
            return;
        }
        this.messages.push(res.data);
        this.lastMessageId = res.data.id;
        this.newMessage = '';
        this.replyTo = null;
        await this.service.render();
        this.scrollToBottom();
    }

    public setReply(m: Message) {
        this.replyTo = m;
    }

    public cancelReply() {
        this.replyTo = null;
    }

    public startEdit(m: Message) {
        this.editingId = m.id;
        this.editingContent = m.content;
    }

    public cancelEdit() {
        this.editingId = '';
        this.editingContent = '';
    }

    public async saveEdit() {
        if (!this.editingId) return;
        const res = await wiz.call('edit', { message_id: this.editingId, content: this.editingContent });
        if (res.code === 200) {
            const idx = this.messages.findIndex(m => m.id === this.editingId);
            if (idx >= 0) this.messages[idx] = res.data;
            this.cancelEdit();
            await this.service.render();
        }
    }

    public async deleteMessage(m: Message) {
        if (!confirm('이 메시지를 삭제하시겠습니까?')) return;
        const res = await wiz.call('delete', { message_id: m.id });
        if (res.code === 200) {
            const idx = this.messages.findIndex(x => x.id === m.id);
            if (idx >= 0) {
                this.messages[idx].deleted = true;
                this.messages[idx].content = '[삭제된 메시지]';
            }
            await this.service.render();
        }
    }

    public async togglePinMessage(m: Message) {
        const res = await wiz.call('pin_message', { message_id: m.id });
        if (res.code === 200) {
            m.pinned = res.data.pinned;
            await this.openRoom(this.room!.id); // refresh pinned list
        }
    }

    public async react(m: Message, emoji: string) {
        const res = await wiz.call('react', { message_id: m.id, emoji });
        if (res.code === 200) {
            // refresh reactions for this message
            const rres = await wiz.call('reactions', { message_ids: m.id });
            if (rres.code === 200) {
                Object.assign(this.reactions, rres.data || {});
            }
            await this.service.render();
        }
    }

    public reactionList(messageId: string): any[] {
        const r = this.reactions[messageId];
        if (!r) return [];
        return Object.values(r);
    }

    public hasMyReaction(messageId: string, emoji: string): boolean {
        const r = this.reactions[messageId];
        if (!r || !r[emoji]) return false;
        const myId = this.service.auth?.session?.id || '';
        return r[emoji].users.includes(myId);
    }

    public openCreateRoom() {
        this.showCreateRoom = true;
        this.newRoom = { type: 'group', name: '', members: '' };
    }

    public closeCreateRoom() {
        this.showCreateRoom = false;
    }

    public async createRoom() {
        const memberIds = this.newRoom.members.split(',').map((s: string) => s.trim()).filter((s: string) => s);
        if (this.newRoom.type !== 'dm' && !this.newRoom.name) {
            this.service.alert.show({ title: '입력 오류', message: '방 이름을 입력하세요.', action: '확인' });
            return;
        }
        const res = await wiz.call('create_room', {
            type: this.newRoom.type,
            name: this.newRoom.name,
            members: JSON.stringify(memberIds),
        });
        if (res.code !== 200) {
            this.service.alert.show({ title: '오류', message: res.data || '방 생성 실패', action: '확인' });
            return;
        }
        this.closeCreateRoom();
        await this.loadRooms();
        await this.openRoom(res.data.id);
    }

    public async toggleMute() {
        if (!this.room) return;
        const res = await wiz.call('mute', { room_id: this.room.id });
        if (res.code === 200) {
            this.room._member = { ...(this.room._member || {}), muted: res.data.muted };
            await this.service.render();
        }
    }

    public async toggleFavorite() {
        if (!this.room) return;
        const res = await wiz.call('favorite', { room_id: this.room.id });
        if (res.code === 200) {
            this.room._member = { ...(this.room._member || {}), favorite: res.data.favorite };
            await this.service.render();
        }
    }

    public async leaveRoom() {
        if (!this.room) return;
        if (!confirm('이 방을 나가시겠습니까?')) return;
        const res = await wiz.call('leave', { room_id: this.room.id });
        if (res.code === 200) {
            this.room = null;
            this.router.navigateByUrl('/admin/collab/chat');
            await this.loadRooms();
        }
    }

    public async addMember() {
        if (!this.room) return;
        const uid = prompt('초대할 사용자 ID:');
        if (!uid) return;
        const res = await wiz.call('add_member', { room_id: this.room.id, user_id: uid });
        if (res.code === 200) {
            await this.openRoom(this.room.id);
        } else {
            this.service.alert.show({ title: '오류', message: res.data || '초대 실패', action: '확인' });
        }
    }

    public openSearch() {
        this.showSearch = true;
        this.searchText = '';
        this.searchResults = [];
    }

    public async runSearch() {
        if (!this.searchText.trim()) return;
        const params: any = { text: this.searchText };
        if (this.room) params.room_id = this.room.id;
        const res = await wiz.call('search', params);
        if (res.code === 200) {
            this.searchResults = res.data || [];
            await this.service.render();
        }
    }

    public roomLabel(r: Room): string {
        if (r.name) return r.name;
        if (r.type === 'dm' && r.members) {
            const myId = this.service.auth?.session?.id || '';
            const other = r.members.find(m => m.user_id !== myId);
            return other ? other.user_id : '1:1 대화';
        }
        return '(이름 없음)';
    }

    public roomTypeIcon(r: Room): string {
        if (r.type === 'dm') return 'fa-user';
        if (r.type === 'channel') return 'fa-hashtag';
        return 'fa-users';
    }

    public formatTime(ts: string | undefined): string {
        if (!ts) return '';
        try {
            const d = new Date(ts);
            const now = new Date();
            if (d.toDateString() === now.toDateString()) {
                return d.toLocaleTimeString('ko-KR', { hour: '2-digit', minute: '2-digit' });
            }
            return d.toLocaleDateString('ko-KR', { month: 'numeric', day: 'numeric' });
        } catch (e) {
            return ts;
        }
    }

    public formatDateTime(ts: string | undefined): string {
        if (!ts) return '';
        try {
            return new Date(ts).toLocaleString('ko-KR');
        } catch (e) {
            return ts;
        }
    }

    public isMine(m: Message): boolean {
        const myId = this.service.auth?.session?.id || '';
        return m.sender_id === myId;
    }

    public messageById(id: string): Message | undefined {
        return this.messages.find(m => m.id === id);
    }

    public threadCount(m: Message): number {
        return this.messages.filter(x => x.parent_message_id === m.id).length;
    }
}

export default PortalLpsysadminCollabChatComponent;